import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { NavigationError } from '@angular/router';

/**
 * Recupera la app cuando un deploy la dejó con el build caduco.
 *
 * Cada deploy borra los chunks del build anterior; una pestaña que quedó
 * abierta con el build viejo falla al navegar a una ruta lazy ("Failed to
 * fetch dynamically imported module") y el usuario queda atorado, típicamente
 * en el login. Recargar la página baja el build nuevo y la navegación llega
 * sola a su destino.
 */

const CLAVE_ULTIMA_RECARGA = 'gmg_recarga_por_chunk';
const MIN_MS_ENTRE_RECARGAS = 60_000;

/** Mensajes de Chrome/Edge, Firefox y Safari para un import dinámico fallido. */
const PATRON_CHUNK_FALLIDO =
  /dynamically imported module|Importing a module script failed|ChunkLoadError/i;

export function recargarSiChunkCaduco(evento: NavigationError): void {
  if (!isPlatformBrowser(inject(PLATFORM_ID))) return;

  const mensaje =
    evento.error instanceof Error ? evento.error.message : String(evento.error ?? '');
  if (!PATRON_CHUNK_FALLIDO.test(mensaje)) return;

  // Si el fallo no venía de un build caduco, recargar no lo arregla: máximo
  // una recarga por minuto para no entrar en bucle.
  try {
    const ultima = Number(sessionStorage.getItem(CLAVE_ULTIMA_RECARGA)) || 0;
    if (Date.now() - ultima < MIN_MS_ENTRE_RECARGAS) return;
    sessionStorage.setItem(CLAVE_ULTIMA_RECARGA, String(Date.now()));
  } catch {
    // Sin sessionStorage (modo privado estricto) se recarga de todos modos.
  }

  // Se navega directo a la URL que se intentaba abrir, ya con el build nuevo.
  window.location.assign(evento.url);
}
